// Captures the client's current time so the server can record clock drift
// (client UTC vs. server UTC) in observability. We send UTC plus the local
// wall-clock time with its timezone offset and the IANA timezone name.
export function getClientTimeFields(): Record<string, string> {
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, "0");
    // getTimezoneOffset() is minutes *behind* UTC, so negate to get the
    // conventional "minutes east of UTC" offset.
    const tzOffsetMinutes = -now.getTimezoneOffset();
    const sign = tzOffsetMinutes >= 0 ? "+" : "-";
    const absOffset = Math.abs(tzOffsetMinutes);
    const offset = `${sign}${pad(Math.floor(absOffset / 60))}:${pad(
        absOffset % 60
    )}`;
    const localIso =
        `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
            now.getDate()
        )}` +
        `T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(
            now.getSeconds()
        )}${offset}`;

    let timezone = "";
    try {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? "";
    } catch (e) {}

    return {
        client_time_utc: now.toISOString(),
        client_time_local: localIso,
        client_timezone: timezone,
        client_tz_offset_minutes: String(tzOffsetMinutes),
    };
}
